import Swiper from 'swiper'
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

class ProductReviews extends HTMLElement {
    
    constructor() {
        super();
        this.init();
    }

    /**
     * Initializes the side cart by setting up events.
     */
    private init(): void {
        this.setupEventListeners();
        this.getReviews();
    }

    /**
     * Sets up event listeners for the side cart.
     */
    private setupEventListeners(): void {
       
    }

    private getReviews () {
        const productId = this.dataset.productId
        const storeId = this.dataset.storeId
        
        if (!productId || !storeId ) {
            return
        }

        try {
            fetch(`https://api.okendo.io/v1/stores/${storeId}/products/shopify-${productId}/reviews`)
            .then(response => response.json())
            .then(data => {
                this.renderReviews(data)
                this.renderReviewsMobile(data)
            });
        } catch (error) {
            
        }
    }

    private groupByThree(arr: any[]) {
        const result: any[] = [];
        for (let i = 0; i < arr.length; i += 3) {
            result.push(arr.slice(i, i + 3));
        }
        return result;
    }
    

    private renderReviews(data: any) {
        const swiperEl = this.querySelector('.swiper-wrapper')
        let temp = this.querySelector('template')
        let slide = temp?.content.querySelector('.swiper-slide') || document.createElement('div')
        
        if (!data.reviews) {
            return
        }

        const groupedReviews = this.groupByThree(data.reviews);

        for (const group of groupedReviews) {
            let slideNew = document.importNode(slide, true)
            let innerHTML = '<div class="reviews">'

            for (const review of group) {
                
                let stars = ''
                let image = slide.getAttribute('data-image')

                for (let j = 1; j <= review.rating; j++) {
                    stars += '<span class="review__star"></span>'
                }

                if (review.media) {
                    image = review.media[0].fullSizeUrl
                }
                innerHTML += `<div class="review">
                                    <div class="review__image" style="--image: url(${image})">
                                        <span class="review__image-author">
                                            ${review.reviewer.displayName}
                                        </span>
                                    </div>
                                    <div class="review__info">
                                        <div class="review__stars">
                                            ${stars}
                                        </div>
                                        <p class="review__content">
                                            ${review.body}
                                        </p>
                                        <span class="review__author">
                                            ${review.reviewer.displayName}
                                        </span>
                                    </div>
                                </div>`
                
            }
            innerHTML += '</div>'
            slideNew.innerHTML = innerHTML
            swiperEl?.appendChild(slideNew)
        }

        this.activateSlider()
    }


    private renderReviewsMobile(data: any) {
        const swiperEl = this.querySelector('.swiper-wrapper-mobile')
        let temp = this.querySelector('template')
        let slide = temp?.content.querySelector('.swiper-slide') || document.createElement('div')
        
        if (!data.reviews) {
            return
        }

        for (const review of data.reviews) {
            let slideNew = document.importNode(slide, true)
            let stars = ''
            let image = slide.getAttribute('data-image')

            for (let j = 1; j <= review.rating; j++) {
                stars += '<span class="review__star"></span>'
            }

            if (review.media) {
                image = review.media[0].fullSizeUrl
            }
            slideNew.innerHTML = `<div class="review">
                                <div class="review__image" style="--image: url(${image})">
                                    <span class="review__image-author">
                                        ${review.reviewer.displayName}
                                    </span>
                                </div>
                                <div class="review__info">
                                    <div class="review__stars">
                                        ${stars}
                                    </div>
                                    <p class="review__content">
                                        ${review.body}
                                    </p>
                                    <span class="review__author">
                                        ${review.reviewer.displayName}
                                    </span>
                                </div>
                            </div>`
           swiperEl?.appendChild(slideNew) 
        }
        this.activateSliderMobile()
    }
    

    private activateSlider() {
        new Swiper("#productReviewsDesktop", {
            modules: [Navigation, Pagination, Thumbs],
            spaceBetween: 20,
            slidesPerView: 1,
            freeMode: true,
            navigation: {
                prevEl: '.product-reviews__slider-left',
                nextEl: '.product-reviews__slider-right'
            }
        });

        this.activateSlideToggle()
    }

    private activateSliderMobile() {
        new Swiper("#productReviewsMobile", {
            modules: [Navigation, Pagination, Thumbs],
            spaceBetween: 20,
            slidesPerView: 'auto'
        });
    }

    private deactiveSlides (container: any) {
        const slides = container.querySelectorAll('.review');
        slides.forEach((slide: any) => {
            slide.classList.remove('active')
            slide.classList.add('inactive')
        });
    }

    private activateSlideToggle () {
        const containers = this.querySelectorAll('.reviews');
        const slides = this.querySelectorAll('.review');

        containers.forEach((container) => {
            const slides = container.querySelectorAll('.review');
            slides[0]?.classList.add('active')
        });        

        slides.forEach((slide) => {
            slide.addEventListener('click', async () => {
                const container = slide.closest('.reviews');
                await this.deactiveSlides(container)
                slide.classList.add('active')
                slide.classList.remove('inactive')
            })
        });
    }

}

export default ProductReviews;
